import {
  useMergeStatusButtonData,
  type ValidatedMergeStatusButtonData,
} from '@github-ui/pull-requests/hooks/use-merge-status-button-data'
import {useLayoutRouteData} from '@github-ui/pull-requests/page-data/loaders/use-layout-route-data'

export function useValidatedMergeData(): ValidatedMergeStatusButtonData | null {
  const {pullRequest, mergeStatusButtonData} = useLayoutRouteData()
  return useMergeStatusButtonData(pullRequest.state, mergeStatusButtonData)
}
